export default __webpack_public_path__ + "static/dismoi-screenshot-le-même-en-local-mounted-website-desktop-f61b5c54bd65247381a48e9dff744fb4.jpg";